/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FaceANeutralIcon16Light } from './FaceANeutralIcon16Light';
import { FaceANeutralIcon16Regular } from './FaceANeutralIcon16Regular';
import { FaceANeutralIcon16Solid } from './FaceANeutralIcon16Solid';
import { FaceANeutralIcon20Light } from './FaceANeutralIcon20Light';
import { FaceANeutralIcon20Regular } from './FaceANeutralIcon20Regular';
import { FaceANeutralIcon20Solid } from './FaceANeutralIcon20Solid';
import { FaceANeutralIcon24Regular } from './FaceANeutralIcon24Regular';
import { FaceANeutralIcon24Solid } from './FaceANeutralIcon24Solid';
import { FaceANeutralIcon32Regular } from './FaceANeutralIcon32Regular';
import { FaceANeutralIcon64Regular } from './FaceANeutralIcon64Regular';
var sizes = {
    16: {
        light: FaceANeutralIcon16Light,
        regular: FaceANeutralIcon16Regular,
        solid: FaceANeutralIcon16Solid,
    },
    20: {
        light: FaceANeutralIcon20Light,
        regular: FaceANeutralIcon20Regular,
        solid: FaceANeutralIcon20Solid,
    },
    24: {
        regular: FaceANeutralIcon24Regular,
        solid: FaceANeutralIcon24Solid,
    },
    32: {
        regular: FaceANeutralIcon32Regular,
    },
    64: {
        regular: FaceANeutralIcon64Regular,
    },
};
export var FaceANeutralIcon = forwardRef('FaceANeutralIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
